// extracted by mini-css-extract-plugin
export default {"loadingWrap":"index-module--loading-wrap--qanMJ"};